import 'vant/lib/rate/index.less'

// 依赖
import '../preview-text/style'
